var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('cc-preview-module',{staticClass:"fd-dbxx-module",attrs:{"title":"担保信息","data":_vm.transformData}},[_c('p',{staticClass:"fd-summery align-right",attrs:{"slot":"extra"},slot:"extra"},[_vm._v("担保总价值："+_vm._s(_vm.dbzjz)+"元")])])}
var staticRenderFns = []

export { render, staticRenderFns }